import { render, staticRenderFns } from "./mixinAxis.vue?vue&type=template&id=3857db06&"
import script from "./mixinAxis.vue?vue&type=script&lang=js&"
export * from "./mixinAxis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/charts/mixinAxis.vue"
export default component.exports